import _asyncToGenerator from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/workdir/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { CustomerDocument } from "@catchoftheday/customer";
import { getEnvConfig } from "@catchoftheday/env-config";
import { ServerGQLClient } from "@catchoftheday/graphql-utils";
import { URL_LEGACY_ONEPASS_ACCOUNT } from "../consts/urls";
export var isActiveOnePassMember = function isActiveOnePassMember(customer) {
  var _membership$subscript;

  var _ref = customer || {},
      club = _ref.club,
      membership = _ref.membership;

  return Boolean((club === null || club === void 0 ? void 0 : club.active) || (membership === null || membership === void 0 ? void 0 : (_membership$subscript = membership.subscription) === null || _membership$subscript === void 0 ? void 0 : _membership$subscript.active));
};
export var isEligibleForOnePassMigration = function isEligibleForOnePassMigration(customer) {
  var _membership$eligibleF;

  var _ref2 = customer || {},
      membership = _ref2.membership;

  return (_membership$eligibleF = membership === null || membership === void 0 ? void 0 : membership.eligibleForMigration) !== null && _membership$eligibleF !== void 0 ? _membership$eligibleF : false;
};
export var isCancellingMembership = function isCancellingMembership(subscription) {
  var _ref3 = subscription || {},
      active = _ref3.active,
      autoRenewing = _ref3.autoRenewing;

  return Boolean(active && !autoRenewing);
};
export var isMembershipFreeTrialEligible = function isMembershipFreeTrialEligible(customer) {
  var _ref4 = customer || {},
      membership = _ref4.membership;

  var _ref5 = membership || {},
      subscription = _ref5.subscription;

  var _ref6 = subscription || {},
      freeTrialEligible = _ref6.freeTrialEligible;

  var isLoggedIn = !!customer;
  var isEligible = freeTrialEligible || !membership || !isLoggedIn;
  return isEligible;
};
export var getOnePassAccountServerSideProps = /*#__PURE__*/function () {
  var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref7) {
    var _membership$subscript2;

    var req, headers, client, _yield$client$query, customerData, _ref9, club, membership;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            req = _ref7.req;
            headers = req.headers;
            client = new ServerGQLClient({
              uri: getEnvConfig().GRAPHQL_ENDPOINT,
              headers: req.headers
            });
            _context.next = 5;
            return client.query({
              query: CustomerDocument,
              headers: headers
            });

          case 5:
            _yield$client$query = _context.sent;
            customerData = _yield$client$query.data;
            _ref9 = (customerData === null || customerData === void 0 ? void 0 : customerData.customer) || {}, club = _ref9.club, membership = _ref9.membership;

            if (!(club !== null && club !== void 0 && club.active && !(membership !== null && membership !== void 0 && membership.linked) && !(membership !== null && membership !== void 0 && (_membership$subscript2 = membership.subscription) !== null && _membership$subscript2 !== void 0 && _membership$subscript2.active))) {
              _context.next = 10;
              break;
            }

            return _context.abrupt("return", {
              redirect: {
                destination: URL_LEGACY_ONEPASS_ACCOUNT,
                permanent: false
              }
            });

          case 10:
            return _context.abrupt("return", {
              props: {}
            });

          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function getOnePassAccountServerSideProps(_x) {
    return _ref8.apply(this, arguments);
  };
}();